import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Blank as Layout } from '../components/layouts';

class Home extends Component {

  componentWillMount() {
    const { auth: { isAuthenticated }, dispatch } = this.props;
    if (isAuthenticated) dispatch(push('/initializing'));
  }

  componentDidMount() {
    const clientHeight = $(window).height();
    $('.platforms').css('height', clientHeight);
  }

  render() {
    const { location: { search }, dispatch } = this.props;
    return (
      <Layout>
        <section className="platforms">
          <row>
            <div className="col-lg-6 col-sm-12 login-left">
              <h1 className='p-m text-center'>Are You A Publisher?</h1>
              <button 
                className="btn btn-lg btn-trans" 
                onClick={() => dispatch(push(`/publisher/login${search}`))}
              > 
                Login Here
              </button>
            </div>
            <div className="col-lg-6 col-sm-12 login-right">
              <h1 className='p-m text-center'>Are You An Advertiser?</h1>
              <button 
                className="btn btn-lg btn-trans" 
                onClick={() => dispatch(push(`/advertiser/login${search}`))}
              > 
                Login Here
              </button>
            </div>
          </row>
        </section> 
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth.data };
};

export default connect(mapStateToProps)(Home);
